(() => {
  const active = new WeakSet();
  const initialize = (root = document) => {
    root.querySelectorAll('.product__media-wrapper > media-gallery.product__column-sticky').forEach((gallery) => {
      if (active.has(gallery)) return;
      active.add(gallery);
      const header = document.querySelector('.section-header');
      const update = () => {
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const galleryHeight = gallery.getBoundingClientRect().height;
        const top = Math.min(headerHeight + 16, window.innerHeight - galleryHeight - 24);
        gallery.style.setProperty('--ranvelle-gallery-sticky-top', top + 'px');
      };
      const observer = new ResizeObserver(update);
      observer.observe(gallery);
      if (header) observer.observe(header);
      window.addEventListener('resize', update, { passive: true });
      const section = gallery.closest('.shopify-section');
      const cleanup = (event) => {
        if (event.target !== section) return;
        observer.disconnect();
        window.removeEventListener('resize', update);
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

